<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.CustomsReceiptFile')"
    width="600px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >

    <cargo-ag-grid
      :show-side-bar="false"
      config-module="1900004"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :style="{width:'100%',height:'400px'}"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button no="1" @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { cacheName, cache } from '@/utils/cacheManager'
import { queryFileByOriginFileId } from '@/api/seaExport/customsInfo'
import { getFileList } from '@/api/storage'
import { sortByMultiField } from '@/utils'
import URL from '@/api/urlTranslator'

export default {
  name: 'CustomsInfoResFileHistoryDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    customsInfoKey: { type: String },
    lob: { type: String, default: '' },
    customsInfo: { type: Object }
  },
  data() {
    return {
      innerVisible: false,
      user: {},
      storageURL: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('FileHistory.fileName'),
          field: 'fileName',
          colId: 'fileName',
          width: 270
        },
        {
          headerName: this.$t('FileHistory.jobType'),
          field: 'fileType',
          colId: 'fileType',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: this.$t('FileHistory.fileSize'),
          field: 'fileSize',
          colId: 'fileSize',
          suppressMenu: true,
          width: 100,
          cellRenderer: params => {
            return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('FileHistory.view'),
          field: '',
          colId: 'viewFile',
          suppressMenu: true,
          width: 100,
          cellRenderer: params => {
            if (params.data.fileId) {
              return `<a href="${URL.common.findByFileId}/${params.data.fileId}?sessionId=${this.user.sessionId}" target="_blank" style="color:#46a6ff">` + this.$t('CargoMsg.Cargo_ViewFile') + '</a>'
            } else {
              return params.value
            }
          }
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  computed: {
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
        this.$emit('uploadDone')
      }
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
  },
  beforeMount() {
  },
  beforeDestroy() {
  },
  methods: {
    async initData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.storageURL = cache.config.get('StorageURL')
      this.rowData = []
      if (this.customsInfoKey) {
        queryFileByOriginFileId({ customsInfoKey: this.customsInfoKey }).then(res => {
          if (res.data) {
            this.toQuery(res.data)
          }
        })
      }
    },
    async toQuery(omsFileKey = '') {
      const xmlParam = '<RequestObject><data><extendMetaData><entry><key>uuid</key><value>' + omsFileKey +
        '</value></entry></extendMetaData></data></RequestObject>'
      const list = await getFileList(xmlParam).then(res => {
        return Array.from(res.data, p => {
          return {
            fileId: p.id,
            fileName: p.fileName,
            fileType: p.extendMetaData.documentType || '',
            fileFormat: p.fileType.split(';')[0],
            fileSize: p.fileSize,
            fileVersion: p.fileVersion || '',
            createDate: p.createDate,
            createChineseName: p.extendMetaData.createChineseName || '',
            createdBy: p.extendMetaData.createdBy,
            extendMetaData: p.extendMetaData,
            fileNameBak: p.fileName,
            path: '',
            hasParent: false,
            parentId: ''
          }
        })
      })
      this.getFilesSucceedHandler(list)
    },
    // 文件列表 父级和子级组装
    getFilesSucceedHandler(list) {
      if (!list || list.length === 0) return
      // 排序后放入临时对象数据
      const rowDataTempt = sortByMultiField(list, ['fileName', 'fileVersion', 'createDate'], true)
      if (!rowDataTempt || rowDataTempt.length === 0) {
        return
      }
      let fatherFile = rowDataTempt[0]
      // 初始化 首个父节点的path
      fatherFile.path = fatherFile.fileId
      fatherFile.hasParent = false
      const source = []
      source.push(fatherFile)
      let childFile
      for (let i = 1; i < rowDataTempt.length; i++) {
        childFile = rowDataTempt[i]
        childFile.hasParent = false
        if (childFile.fileName === fatherFile.fileName) {
          if (fatherFile.hasParent) {
            childFile.path = fatherFile.parentId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.parentId
          } else {
            childFile.path = fatherFile.fileId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.fileId
          }
        } else {
          // 遍历到父节点了
          childFile.path = childFile.fileId
        }
        source.push(childFile)
        fatherFile = childFile
      }
      // 数据组装后 父级再次排序 根据createDate fileName
      let parentFileList = source.filter(val => {
        return val.hasParent === false
      })
      const childFileList = source.filter(val => {
        return val.hasParent === true
      })
      parentFileList = sortByMultiField(parentFileList, ['createDate', 'fileName'], true)

      const fileList = [...parentFileList, ...childFileList]

      this.rowData = fileList
    }
  }
}
</script>

<style scoped>
  .not-click {
    pointer-events: none;
  }
</style>
